import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TableCell from './table-body-cell';
import Topic from './topic';
import Conversation from './conversation';
import Feeling from './feeling';
import Duration from './duration';
import TouchPoint from './touchpoint';
import OtherTopics from './other-topics';
import { TOPICS_CELL_WIDTH_REPARTITION } from '../../utils/constants';

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(2),
        display: 'flex',
        borderRadius: 12,
        overflow: 'hidden',
        cursor: 'pointer'
    },
    darkBg: {
        backgroundColor: '#0b253e',
    },
    lightBg: {
        backgroundColor: '#fff'
    }
}));

const TableBodyRow = ({ onClick, data, key, theme }) => {
    const classes = useStyles();

    const handleClick = () => {
        onClick(data.topicId)
    }

    return (
        <Grid container className={clsx(classes.root, theme ? classes.darkBg: classes.lightBg)} key={key} onClick={handleClick}>
            <TableCell width={TOPICS_CELL_WIDTH_REPARTITION[0] + '%'}>
                <Topic name={data.name} category={data.category} theme={theme}/>
            </TableCell>
            <TableCell width={TOPICS_CELL_WIDTH_REPARTITION[1] + '%'} position="center">
                <Conversation
                    atmosphere={data.comparePreviousPeriod && data.comparePreviousPeriod.atmosphere? data.comparePreviousPeriod.atmosphere: ''} 
                    value={data.conversations} 
                    percentage={data.comparePreviousPeriod && data.comparePreviousPeriod.conversations? data.comparePreviousPeriod.conversations: ''} 
                    theme={theme}
                />
            </TableCell>
            <TableCell width={TOPICS_CELL_WIDTH_REPARTITION[2] + '%'} position="center">
                <Feeling atmosphere={data.atmosphere.mainSentiment} value={data.atmosphere.mainSentimentPercent} theme={theme}/>
            </TableCell>
            <TableCell width={TOPICS_CELL_WIDTH_REPARTITION[3] + '%'} position="center"noPadding>
                <Duration 
                    atmosphere={data.atmosphere.mainSentiment} 
                    duration={data.duration.avg} 
                    percentage={data.comparePreviousPeriod && data.comparePreviousPeriod.durationAvg? data.comparePreviousPeriod.durationAvg: ''} 
                    theme={theme}
                />
            </TableCell>
            <TableCell width={TOPICS_CELL_WIDTH_REPARTITION[4] + '%'} position="center">
                <TouchPoint text={data.touchPoint.text} voice={data.touchPoint.voice} theme={theme}/>
            </TableCell>
            <TableCell width={TOPICS_CELL_WIDTH_REPARTITION[5] + '%'} position="left" noPadding last>
                <OtherTopics topics={data.otherTopics} theme={theme}/>
            </TableCell>
        </Grid>
    )
}

export default TableBodyRow;
